import { select } from '@udecode/plate';
import { findEventRange } from '@udecode/plate-common';

import { uploadFiles } from './uploadFiles';

export const onDrop = (editor, e) => {
  const { files } = e.dataTransfer;
  if (files.length === 0) return false;
  /**
   * Without this, the dropped file replaces the page
   */
  e.preventDefault();
  e.stopPropagation();

  /**
   * When we drop a file, the selection won't move automatically to the drop
   * location. Find the location from the event and upload the files at that
   * location.
   */
  const at = findEventRange(editor, e);
  if (!at) return false;

  select(editor, at);
  uploadFiles(editor, files);

  return true;
};

export const onInputChange = (editor, e) => {
  const { files } = e.target;
  if (files.length === 0) return false;
  /**
   * Without this, the dropped file replaces the page
   */
  e.preventDefault();
  e.stopPropagation();

  uploadFiles(editor, files);
};
